import { THEME_KEY } from '@/core/storage'

export function getStoredTheme() {
  const stored = localStorage.getItem(THEME_KEY)
  return stored === 'dark' ? 'dark' : 'light'
}

export function applyDocumentTheme(mode) {
  document.documentElement.setAttribute('data-theme', mode)
}

export function initTheme() {
  applyDocumentTheme(getStoredTheme())
}
